import { ActionsStatus, EventStatus } from "../../types/status";
import { getStatusInfos } from "../../utils/events/status";

type Props = {
  value: EventStatus | ActionsStatus;
  type: "events" | "actions";
};

function getStyle({ value, type }: Props) {
  return {
    backgroundColor: getStatusInfos(type, value).color,
    color: "white",
    borderRadius: "20px",
    padding: "5px 20px",
    display: "inline-block",
    whiteSpace: "nowrap",
    fontSize: "14px",
  };
}
const StatusBadges: React.FC<Props> = ({ value, type }) => {
  return (
    <span style={getStyle({ value, type })}>
      {getStatusInfos(type, value).label}
    </span>
  );
};

export default StatusBadges;
